package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageOptimizer
import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.model.ImageData
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.validation.ImageValidator

class UploadPreMadeInventoryItemImageUseCase(
    private val imageStorageRepository: ImageStorageRepository,
    private val imageOptimizer: ImageOptimizer
) {
    suspend operator fun invoke(
        tableId: String,
        itemId: String,
        imageData: ImageData
    ): Result<String> {
        ImageValidator.validate(imageData).onFailure { return Result.failure(it) }

        val optimized = imageOptimizer.optimize(imageData).getOrElse {
            return Result.failure(it)
        }

        return imageStorageRepository.upload(
            ImageTarget.PreMadeInventoryItem(tableId, itemId),
            optimized
        )
    }
}
